import * as angular from 'angular';
import { BaseAnalytics } from '../../../../app.common/modules/common/models/dpp-analytics/base-analytics';
import { DppExportCsvService } from '../../../../app.common/modules/common/services/dpp-export-csv.service';
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { RetailerService } from '../../api/retailer.service';
import { IReadingLocationVariationsStatistics } from '../../model/dpp-analytics/reading-location-variations-statistics.interface';
import { VariationsReportFilterEnum } from '../../model/dpp-analytics/variations-report-filter.enum';
import { IVariationsStatistic } from '../../model/dpp-analytics/variations-statistic.interface';
import { DppAnalyticsService } from '../dpp-analytics.service';

export class DownloadsComponent extends BaseAnalytics {
    public static $inject = ['dppExportCsvService', '$translate', 'notificationService', 'retailerService', 'dppAnalyticsService'];

    public variationsStatistics: IReadingLocationVariationsStatistics;
    public filters = [VariationsReportFilterEnum.ALL, VariationsReportFilterEnum.LIMITED, VariationsReportFilterEnum.UNLIMITED];
    public selectedFilter = VariationsReportFilterEnum.ALL;
    public filterExpanded = false;
    public noResults: boolean;
    public nothingToShowYet: boolean;
    public loadedOnce: boolean;

    constructor(
        dppExportCsvService: DppExportCsvService,
        translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private retailerService: RetailerService,
        private dppAnalyticsService: DppAnalyticsService
    ) {
        super(dppExportCsvService, translate);
        this.exportHeaders = ['Product', 'Product type', 'Downloads', 'Unique Users'];
    }

    public async $onInit() {
        this.loadReports();
    }

    public exportCSV() {
        if (this.variationsStatistics) {
            const prefix = this.translate.instant('downloads');
            const items = this.variationsStatistics.VariationStatistics.map((item) => {
                return {
                    Title: item.Title,
                    Free: item.Free ? this.translate.instant('free_title') : this.translate.instant('time_limited'),
                    ViewsCount: item.ViewsCount,
                    ShoppersCount: item.ShoppersCount
                };
            });
            this.export(items, prefix);
        }
    }

    public getImageUrl(report: IVariationsStatistic): string {
        if (report.ImageIDs && report.ImageIDs.length > 0) {
            return this.retailerService.getProductImageUrl(report.ImageIDs[0], 46, 46);
        } else {
            return null;
        }
    }

    public getFilterName(filter: VariationsReportFilterEnum): string {
        switch (filter) {
            case VariationsReportFilterEnum.ALL:
                return this.translate.instant('all_content_type');
            case VariationsReportFilterEnum.LIMITED:
                return this.translate.instant('limited_reading_time');
            case VariationsReportFilterEnum.UNLIMITED:
                return this.translate.instant('unlimited_reading_time');
        }
    }

    public async onChangeFilter(filter: VariationsReportFilterEnum) {
        if (filter !== this.selectedFilter) {
            this.selectedFilter = filter;
            this.loadReports();
        }
    }

    protected async loadReports() {
        this.waiting = true;
        try {
            this.notificationService.showWaitingMessage();
            const response = await this.dppAnalyticsService.getVariationsReport({
                From: this.from,
                To: this.to,
                ReadingTypeFilter: this.selectedFilter
            });
            this.nothingToShowYet = response.status === 204;
            if (!this.nothingToShowYet) {
                this.variationsStatistics = response.data;
                this.noResults = this.variationsStatistics.VariationStatistics.length === 0;
            }
            this.notificationService.clearAll();
            this.loadedOnce = true;
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        }
        this.waiting = false;
    }
}

angular
    .module('naut')
    .component('downloads', {
        template: require('./downloads.component.html'),
        controller: DownloadsComponent,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/dpp-analytics/downloads/downloads.component.ts